export const Reliability_Q2_Check_Details = [
  {
    CheckId: "check_active_vpn_tunnels_status_as_up",
    Description:
      "Both VPN tunnels for an AWS Site-to-Site VPN connection should be up",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Reliability_Q3_Check_Details = [
  {
    CheckId: "direct_connect_redundancy",
    Description: "Direct connect redundancy",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Reliability_Q5_Check_Details = [
  {
    CheckId: "clb_enable_connection_draining",
    Description: "ELB Connection draining must be enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "clb_cross_zone_load_balancing",
    Description: "Enable CLB Cross Zone Load Balancing",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "s3_bucket_version_enable",
    Description: "S3 bucket must have versioning enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Reliability_Q5_s3_bucket_version_enable = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "481678ad-7a9b-4c6d-a98f-90bccbddd6e8",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "reliability",
      QuestionId: "mitigate-interaction-failure",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "4be8f701-2690-48b6-8afb-5cf968642928",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "reliability",
      QuestionId: "mitigate-interaction-failure",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "54fcd399-1a6b-43f0-9743-5784cd544a92",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "reliability",
      QuestionId: "mitigate-interaction-failure",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "555be8cc-d556-4032-8503-35bc847b1492",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "reliability",
      QuestionId: "mitigate-interaction-failure",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "61728214-659d-47fb-a134-9cd50f9405ac",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "reliability",
      QuestionId: "mitigate-interaction-failure",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_version_enable",
      CreatedAt: "2023-04-25 12:23:48",
      FindingId: "938b1c16-c896-4e68-9e7d-12e37d1b247c",
      Metadata: {
        TaskRefId: "36066b12-b0f8-46f7-bb8c-0ea735b46a91",
      },
      PillarId: "reliability",
      QuestionId: "mitigate-interaction-failure",
      Recommendation:
        "S3 object versioning provides extra layer of data protection and/ or data retention, versioning enables you to recover and preserve deleted objects from S3 bucket. This check verifies if versioning is enabled for your S3 buckets.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 6,
};

export const Reliability_Q6_Check_Details = [
  {
    CheckId: "emr_cluster_logging_check",
    Description: "EMR cluster logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "kms_key_rotation_enabled",
    Description: "Enable Key Rotation for KMS customer master key",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "kinesis_analytics_application_log_to_cloudwatch_check",
    Description: "Kinesis analytics application log to CloudWatch",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloudtrail_logs_encrypted_at_rest",
    Description: "CloudTrail logs are encrypted at rest using SSE-KMS",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "configuration_status_check",
    Description: "AWS Config is enabled in all regions",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_security_group_changes",
    Description:
      "Ensure a log metric filter and alarm exist for security group changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_route_table_changes",
    Description:
      "Ensure a log metric filter and alarm exist for route table changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "appmesh_logging_check",
    Description:
      "App Mesh virtual nodes should define an HTTP access log path to enable log exports for Envoy proxies",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_enable_event_notification_check",
    Description: "Enable RDS Event Notification",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_unauthorized_api_call_changes",
    Description:
      "Ensure a log metric filter and alarm exist for unauthorized API calls",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "amb_fabric_node_chaincode_logging_check",
    Description: "Fabric peer node chaincode logs enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_without_mfa_signin_changes",
    Description:
      "Ensure a log metric filter and alarm exist for Management Console sign-in without MFA",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "is_cloudwatch_logging_enabled",
    Description:
      "Ensure CloudWatch logging enabled for CodeBuild for audit pupose.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloud_trail_s3_bucket_publicly_accessible_check",
    Description:
      "Ensure the S3 bucket used to store CloudTrail logs is not publicly accessible",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_s3_changes",
    Description:
      "Ensure a log metric filter and alarm exist for S3 bucket policy changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_aws_config_changes",
    Description:
      "Ensure a log metric filter and alarm exist for AWS Config configuration changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_iam_policy_changes",
    Description:
      "Ensure a log metric filter and alarm exist for IAM policy changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "blockchain_fabric_peer_node_logs_enabled",
    Description:
      "Peer node logs allow you to debug timeout errors associated with proposals and identify rejected proposals",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_console_authentication_failure",
    Description:
      "Ensure a log metric filter and alarm exist for AWS Management Console authentication failures",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "elbv2_nlb_tls_logging_check",
    Description: "Do NLBs with TLS listeners have access logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "broker_audit_logging_check",
    Description: "Amazon MQ Message brokers should have audit logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "neptune_cluster_audit_logging_check",
    Description: "Neptune audit logging enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "vpc_flow_log_enabled_check",
    Description: "Ensure VPC flow logging is enabled in all VPCs",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_network_gateway_changes",
    Description:
      "Ensure a log metric filter and alarm exist for changes to network gateways",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_root_account_changes",
    Description:
      "Ensure a log metric filter and alarm exist for usage of root user",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_cmk_api_call_changes",
    Description:
      "Ensure a log metric filter and alarm exist for disabling or scheduled deletion of customer managed keys",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "clb_access_logging_check",
    Description: "Classic Load Balancer logging should be enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloud_trail_s3_bucket_logging_enabled_check",
    Description:
      "S3 bucket access logging is enabled on the CloudTrail S3 bucket",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "documentdb_cluster_audit_logging_on",
    Description: "Ensure DocDB cluster audit logging is turned on",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloud_trail_multi_region",
    Description: "AWS CloudTrail must be enabled with multi-region option",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "is_stage_api_logging_enabled",
    Description: "Ensure stage API logging enabled on API Gateway",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "cloud_trail_organizational_check",
    Description: "Cloudtrail for an organization",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_aws_cloud_trail_changes",
    Description:
      "Ensure a log metric filter and alarm exist for CloudTrail configuration changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "redshift_cluster_logging_check",
    Description: "Redshift cluster audit logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloud_trail_log_file_validation",
    Description: "CloudTrail log file validation must be enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "are_global_management_events_logged",
    Description:
      'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "amb_fabric_member_ca_logging_check",
    Description: "Fabric member CA logs enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elb_access_logging_check",
    Description: "ELBv2 has access logs enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "broker_general_logging_check",
    Description:
      "Amazon MQ Message brokers should have general logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_nacl_changes",
    Description:
      "Ensure a log metric filter and alarm exist for changes to Network Access Control Lists (NACL)",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "rds_instance_cloudwatch_logging_check",
    Description: "Enable CloudWatch logging for RDS databases ",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_vpc_changes",
    Description: "Ensure a log metric filter and alarm exist for VPC changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "s3_bucket_logging_enable",
    Description: "S3 bucket should have server access logging enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "rds_enable_event_notification_check",
    Description: "Enable RDS Event Notification",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "is_cloudwatch_log_forwarding_enabled",
    Description:
      "Ensure log forwarding enabled on Directory Service directory, this helps you to meet your security monitoring, audit, and log retention policy requirements by providing transparency of the security events in your directory.",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Reliability_Q6__emr_cluster_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__kms_key_rotation_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "kms_key_rotation_enabled",
      CreatedAt: "2023-04-25 12:25:08",
      FindingId: "3e949ab5-f22b-4c28-8cc0-fa2bfae8b599",
      Metadata: {
        TaskRefId: "12d51cb5-80ca-4cf1-ad97-f92fc5998a01",
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Cryptographic best practices discourage extensive reuse of encryption keys. When you enable automatic key rotation for a KMS key, AWS KMS generates new cryptographic material for the KMS key every year. This check verifies if KMS Key rotation is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "66d0e6fe-1ae2-4919-85b8-6966f7e2c1c7",
      ResourceType: "KMSKey",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__kinesis_analytics_application_log_to_cloudwatch_check =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [],
    TotalRecords: 0,
  };
export const Reliability_Q6__cloudtrail_logs_encrypted_at_rest = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloudtrail_logs_encrypted_at_rest",
      CreatedAt: "2023-04-25 12:23:27",
      FindingId: "2e5f9c6f-03f5-4ba0-95d3-46bfbe9cf500",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Ensure that your CloudTrail logs are encrypted at rest using server-side encryption provided by AWS KMS–Managed Keys (SSE-KMS) to enhance the security of your CloudTrail bucket and allow you to have better control over who can read the log files in your organization",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloudtrail_logs_encrypted_at_rest",
      CreatedAt: "2023-04-25 12:23:27",
      FindingId: "ebe1ff3e-67a9-4995-8e20-9a41aae3f789",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Ensure that your CloudTrail logs are encrypted at rest using server-side encryption provided by AWS KMS–Managed Keys (SSE-KMS) to enhance the security of your CloudTrail bucket and allow you to have better control over who can read the log files in your organization",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q6__configuration_status_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__log_metric_filter_for_security_group_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_security_group_changes",
      CreatedAt: "2023-04-25 12:23:42",
      FindingId: "d2d8e868-99b2-410c-9195-7b552db04755",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to security groups present. Monitoring these changes helps ensure that resources and services aren't unintentionally exposed.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__log_metric_filter_for_route_table_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_route_table_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "2931104b-c957-49e4-baa5-8b52b4cdd752",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to route tables is present. Monitoring these changes helps ensure that all VPC traffic flows through an expected path.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__appmesh_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__rds_enable_event_notification_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_enable_event_notification_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "766fa1cb-9155-476d-98a9-e9bd8d035447",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Ensure that your AWS RDS resources have event notifications enabled in order to be notified when an event occurs for a given database instance, database snapshot, database security group or database parameter group.  these events are grouped into categories that you can subscribe to so that you can be notified via AWS SNS when an event in that category occurs.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_enable_event_notification_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "bc761df7-193d-4975-90d5-e60a6d163145",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Ensure that your AWS RDS resources have event notifications enabled in order to be notified when an event occurs for a given database instance, database snapshot, database security group or database parameter group.  these events are grouped into categories that you can subscribe to so that you can be notified via AWS SNS when an event in that category occurs.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_enable_event_notification_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "c5d5178f-be7a-47a7-b08b-52fed7850262",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Ensure that your AWS RDS resources have event notifications enabled in order to be notified when an event occurs for a given database instance, database snapshot, database security group or database parameter group.  these events are grouped into categories that you can subscribe to so that you can be notified via AWS SNS when an event in that category occurs.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_enable_event_notification_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "e0361343-211a-4831-a886-bb1122528c98",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Ensure that your AWS RDS resources have event notifications enabled in order to be notified when an event occurs for a given database instance, database snapshot, database security group or database parameter group.  these events are grouped into categories that you can subscribe to so that you can be notified via AWS SNS when an event in that category occurs.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 4,
};
export const Reliability_Q6__log_metric_filter_for_unauthorized_api_call_changes =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [
      {
        AccountNumber: "181570489212",
        CheckId: "log_metric_filter_for_unauthorized_api_call_changes",
        CreatedAt: "2023-04-25 12:23:43",
        FindingId: "aa1bfac5-c964-44e2-a698-6d10a90be8fb",
        Metadata: {
          TaskRefId: null,
        },
        PillarId: "reliability",
        QuestionId: "monitor-aws-resources",
        Recommendation:
          "This rule checks whether a metric filter and alarm unauthorized API calls is present. Monitoring unauthorized API calls helps reveal application errors and might reduce time to detect malicious activity.",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId: "181570489212/us-east-1",
        ResourceType: "LogMetricFilter",
        Severity: "Low",
        Status: "Failed",
      },
    ],
    TotalRecords: 1,
  };
export const Reliability_Q6__amb_fabric_node_chaincode_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__log_metric_filter_for_without_mfa_signin_changes =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [
      {
        AccountNumber: "181570489212",
        CheckId: "log_metric_filter_for_without_mfa_signin_changes",
        CreatedAt: "2023-04-25 12:23:42",
        FindingId: "771505a6-4eae-49a7-8ca8-6bde33fa46eb",
        Metadata: {
          TaskRefId: null,
        },
        PillarId: "reliability",
        QuestionId: "monitor-aws-resources",
        Recommendation:
          "This rule checks whether a metric filter and alarm console logins that aren't protected by MFA is present. Monitoring for single-factor console logins increases visibility into accounts that aren't protected by MFA.",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId: "181570489212",
        ResourceType: "LogMetricFilter",
        Severity: "Low",
        Status: "Failed",
      },
    ],
    TotalRecords: 1,
  };
export const Reliability_Q6__is_cloudwatch_logging_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__cloud_trail_s3_bucket_publicly_accessible_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_s3_bucket_publicly_accessible_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "99f590e3-e7eb-4d89-a84c-fc801fcaac72",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Check for any publicly accessible CloudTrail trail log buckets (i.e. target buckets) in order to determine if your AWS cloud account could be at risk",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_s3_bucket_publicly_accessible_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "c0917adc-08e6-4ab9-8bfc-e00cdd7afbea",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Check for any publicly accessible CloudTrail trail log buckets (i.e. target buckets) in order to determine if your AWS cloud account could be at risk",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q6__log_metric_filter_for_s3_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_s3_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "9122abbc-9985-4155-a5ec-569ffcc7430e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to S3 bucket policies is present. Monitoring these changes might reduce time to detect and correct permissive policies on sensitive S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__log_metric_filter_for_aws_config_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_aws_config_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "7be038c1-b68e-4109-8025-8c66a51aab71",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to AWS Config configuration settings is present. Monitoring these changes helps ensure sustained visibility of configuration items in the account.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__log_metric_filter_for_iam_policy_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_iam_policy_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "70f3c361-ece5-41ae-936a-38af84d31a7f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes made to IAM policies is present. Monitoring these changes helps ensure that authentication and authorization controls remain intact",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "LogMetricFilter",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__blockchain_fabric_peer_node_logs_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__log_metric_filter_for_console_authentication_failure =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [
      {
        AccountNumber: "181570489212",
        CheckId: "log_metric_filter_for_console_authentication_failure",
        CreatedAt: "2023-04-25 12:23:43",
        FindingId: "26968ebf-b48e-497d-a8c8-608df5cc25af",
        Metadata: {
          TaskRefId: null,
        },
        PillarId: "reliability",
        QuestionId: "monitor-aws-resources",
        Recommendation:
          "This rule checks whether a metric filter and alarm for failed console authentication attempts is present",
        RegionCode: "us-east-1",
        Remediation: false,
        ResourceId: "181570489212",
        ResourceType: "LogMetricFilter",
        Severity: "Low",
        Status: "Failed",
      },
    ],
    TotalRecords: 1,
  };
export const Reliability_Q6__elbv2_nlb_tls_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__broker_audit_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__neptune_cluster_audit_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "neptune_cluster_audit_logging_check",
      CreatedAt: "2023-04-25 12:24:43",
      FindingId: "2d1034c6-e4c6-4cf8-9ffa-657b56f5d718",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "To audit Amazon Neptune DB cluster activity, enable the collection of audit logs by setting a DB cluster parameter. When audit logs are enabled, you can use it to log any combination of supported events. You can view or download the audit logs to review them.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "humantech-production-auroradbnc-auroradbclusternc-h0etehondbyg",
      ResourceType: "NeptuneCluster",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__vpc_flow_log_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "4382dec1-8cae-4857-aa45-bc4920dc03f8",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0bdc428505f6126ff",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "ac9ca591-052d-4931-aeac-2679aa2a5fda",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d2474fa5d3855b82",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "b2a06a05-c79a-4222-bf03-005a40866c35",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0ead93409c28ef71f",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "vpc_flow_log_enabled_check",
      CreatedAt: "2023-04-25 12:25:10",
      FindingId: "f03bf3c3-2cf9-4841-b3ac-f73288f06cd4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control identifies flow logging is enabled on VPCs within AWS account, VPC flow logs is a feature that enables you to capture information about the IP traffic going to and from network interfaces in your VPC",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vpc-0d8fcaa7ed8e6b2a1",
      ResourceType: "Vpc",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 4,
};
export const Reliability_Q6__log_metric_filter_for_network_gateway_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_network_gateway_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "b969382a-37c2-44a9-8f93-ece2a68f4bcb",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to network gateways is present. Monitoring these changes helps ensure that all ingress and egress traffic traverses the VPC border via a controlled path.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__log_metric_filter_for_root_account_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_root_account_changes",
      CreatedAt: "2023-04-25 12:23:42",
      FindingId: "0986e709-59df-4e03-a4d3-28e83ee5bec3",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for root user login attempts is present. Monitoring for root user logins provides visibility into the use of a fully privileged account and an opportunity to reduce the use of it.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__log_metric_filter_for_cmk_api_call_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_cmk_api_call_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "a21aee25-61f1-4433-83cf-c284477a38ff",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Ensure a log metric filter and alarm exist for disabling or scheduled deletion of customer managed keys",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__clb_access_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__cloud_trail_s3_bucket_logging_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_s3_bucket_logging_enabled_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "324af211-fd6e-4144-ba92-26a199c0cde6",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Ensure that any S3 buckets used by AWS CloudTrail have Server Access Logging feature enabled in order to track requests for accessing the buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_s3_bucket_logging_enabled_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "50838c54-b59a-4f54-a11f-064aec003756",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "Ensure that any S3 buckets used by AWS CloudTrail have Server Access Logging feature enabled in order to track requests for accessing the buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "CloudTrail",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q6__documentdb_cluster_audit_logging_on = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__cloud_trail_multi_region = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_multi_region",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "bfccf4e5-3d45-4ff2-9745-e16907d5869d",
      Metadata: {
        TaskRefId: "73b2405d-d8d6-481f-b197-c9399ac0cd00",
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "To ensure that you log global service events and capture all management event activity in your AWS account, you should create trails that log events in all AWS Regions. This check verifies if multi-region option is enabled for your AWS CloudTrail.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_multi_region",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "10142f70-7b01-4a78-9b00-0ed63cf9462d",
      Metadata: {
        TaskRefId: "73b2405d-d8d6-481f-b197-c9399ac0cd00",
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "To ensure that you log global service events and capture all management event activity in your AWS account, you should create trails that log events in all AWS Regions. This check verifies if multi-region option is enabled for your AWS CloudTrail.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q6__is_stage_api_logging_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "is_stage_api_logging_enabled",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "444638b1-0eab-41b9-ae85-24e22239d401",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation: "Ensure stage API logging enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/unencrpytcache",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "is_stage_api_logging_enabled",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "9223ed1d-b77b-434f-8aca-ad3c34d12179",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation: "Ensure stage API logging enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/dev",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q6__cloud_trail_organizational_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_organizational_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "52fa6c7a-d7d2-4ea0-ac38-0b24fe3cbc21",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether created trails are organization trail, Organization trails log events for the management account and all member accounts in the organization, which also helps you centralize trail logs of all Organization accounts into one place.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_organizational_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "cfae8786-421c-4f0b-8547-00d37e3d5d8b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether created trails are organization trail, Organization trails log events for the management account and all member accounts in the organization, which also helps you centralize trail logs of all Organization accounts into one place.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q6__log_metric_filter_for_aws_cloud_trail_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_aws_cloud_trail_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "5ac84c5e-2d07-4e04-b24a-e98639968b99",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to CloudTrail configuration settings is present. Monitoring these changes helps ensure sustained visibility to activities in the accoun",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__redshift_cluster_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__cloud_trail_log_file_validation = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_log_file_validation",
      CreatedAt: "2023-04-25 12:23:27",
      FindingId: "f0be8c7e-08fe-44bc-86a8-fafa9b740ad0",
      Metadata: {
        TaskRefId: "55cf621d-04c8-4712-96f5-cbfa751d5439",
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "CloudTrail log file validation creates a digitally signed digest file that contains a hash of each log that CloudTrail writes to Amazon S3. You can use these digest files to determine whether a log file was changed, deleted, or unchanged after CloudTrail delivered the log. This check verifies if CloudTrail log file validation is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_log_file_validation",
      CreatedAt: "2023-04-25 12:23:27",
      FindingId: "c1e5edf9-b974-41ab-9015-655b22c58b9a",
      Metadata: {
        TaskRefId: "55cf621d-04c8-4712-96f5-cbfa751d5439",
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "CloudTrail log file validation creates a digitally signed digest file that contains a hash of each log that CloudTrail writes to Amazon S3. You can use these digest files to determine whether a log file was changed, deleted, or unchanged after CloudTrail delivered the log. This check verifies if CloudTrail log file validation is enabled.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q6__are_global_management_events_logged = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "are_global_management_events_logged",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "524e79cb-4099-4ce5-8257-6d08b97c2903",
      Metadata: {
        TaskRefId: "55f3b24e-4711-4c6d-b492-db3ac3abfd9e",
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_global_management_events_logged",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "0172de84-07ce-4091-8c0a-39692ae8dc27",
      Metadata: {
        TaskRefId: "55f3b24e-4711-4c6d-b492-db3ac3abfd9e",
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q6__amb_fabric_member_ca_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__elb_access_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "elb_access_logging_check",
      CreatedAt: "2023-04-25 12:23:35",
      FindingId: "9451cd43-a4c3-4d3f-8fb7-22a03797431d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control check whether the logging is enabled on ELBv2",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:elasticloadbalancing:us-east-1:181570489212:loadbalancer/app/WARtestELBv2NC-181570489212/cc7069d88209b2eb",
      ResourceType: "LoadBalancer",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__broker_general_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q6__log_metric_filter_for_nacl_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_nacl_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "95bb87d0-1353-423b-8352-f6310280840a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to NACLs is present. Monitoring these changes helps ensure that AWS resources and services aren't unintentionally exposed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__rds_instance_cloudwatch_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_cloudwatch_logging_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "11337b55-c3c2-47c6-b990-a0c184ecd25e",
      Metadata: {
        TaskRefId: "5fc5c01f-6db1-43b9-b9f4-401dea001486",
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "By publishing database logs to Amazon CloudWatch, you can build richer and more seamless interactions with your database instance logs using AWS services. Log Exports is supported by AWS RDS MySQL, Aurora (with MySQL compatibility) and MariaDB database engines. \n This check verifies if CloudWatch logging is enabled for Amazon RDS database instances.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_cloudwatch_logging_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "8973b6f0-8c66-484b-a9a6-2cba9cfa6bc8",
      Metadata: {
        TaskRefId: "5fc5c01f-6db1-43b9-b9f4-401dea001486",
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "By publishing database logs to Amazon CloudWatch, you can build richer and more seamless interactions with your database instance logs using AWS services. Log Exports is supported by AWS RDS MySQL, Aurora (with MySQL compatibility) and MariaDB database engines. \n This check verifies if CloudWatch logging is enabled for Amazon RDS database instances.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q6__log_metric_filter_for_vpc_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_vpc_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "ec280e06-3388-4c54-a2a0-96bc83a34a0e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to VPCs is present. Monitoring these changes helps ensure that authentication and authorization controls remain intact",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q6__s3_bucket_logging_enable = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "10117ab8-586e-449a-a5c4-39bfe1d83e58",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::montycloud-inventorybucketdatasync-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "206c47c7-ea97-4a12-b351-0c0f6d1e00b0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::cf-templates-10nzlz76e38mp-us-east-1",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "2167bf06-67f5-432c-859c-f3d55cb66178",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-config-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "45c36c96-c982-4087-96f0-59af85f58091",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::wafr-test-bucket-cibi-apr2523",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "8afe1894-45a8-4413-aa91-43026dbfbb16",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "s3_bucket_logging_enable",
      CreatedAt: "2023-04-25 12:23:47",
      FindingId: "8c43b2d9-50fd-4f8c-a0fd-2340e23eb360",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "monitor-aws-resources",
      Recommendation:
        "This control checks whether server access logging is enabled for S3 buckets, Server access logging provides detailed records of requests made to a bucket. Server access logs can assist in security and access audits.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "S3",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 6,
};

export const Reliability_Q6__is_cloudwatch_log_forwarding_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

export const Reliability_Q9_Check_Details = [
  {
    CheckId: "rds_db_cluster_snapshot_age_check",
    Description: "RDS cluster Old Snapshots",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "ebs_snapshot_public_check",
    Description:
      "AWS Elastic Block Store (EBS) volume snapshots must not publicly shared",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "rds_automated_backup_check",
    Description: "Enable automated backups for RDS",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "volume_backup_check",
    Description: "EBS Volumes should have snapshots",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "dynamodb_tables_backed_up",
    Description:
      "Ensure DynamoDB tables are backed up to avoid potential loss of data",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "enable_dynamodb_point_in_time_recovery",
    Description: "Enable DynamoDB table point-in-time recovery",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ec2_instance_backup_check",
    Description: "EC2 instances backed up",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ebs_snapshot_age_check",
    Description: "EBS Old Snapshots",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_snapshot_public_access_check",
    Description: "RDS DB Public Snapshots",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "fsx_automated_backup_enabled_check",
    Description: "Enable FSx Automated backups",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Reliability_Q9__rds_db_cluster_snapshot_age_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_db_cluster_snapshot_age_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "7e6ce6e7-7708-4a36-a725-93c6a3f64809",
      Metadata: {
        TaskRefId: "0c65fe87-ac3b-40fe-9103-a20cae88cc24",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Check for any DB snapshots older than 30 days available within your AWS account",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "humantech-workload-resources-auroradbnc-djzuytdb496a-snapshot-auroradbclusternc-dgftqptmsie7",
      ResourceType: "RdsClusterSnapshot",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};

export const Reliability_Q9_rds_db_cluster_snapshot_age_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_db_cluster_snapshot_age_check",
      CreatedAt: "2023-04-25 12:24:37",
      FindingId: "7e6ce6e7-7708-4a36-a725-93c6a3f64809",
      Metadata: {
        TaskRefId: "0c65fe87-ac3b-40fe-9103-a20cae88cc24",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Check for any DB snapshots older than 30 days available within your AWS account",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "humantech-workload-resources-auroradbnc-djzuytdb496a-snapshot-auroradbclusternc-dgftqptmsie7",
      ResourceType: "RdsClusterSnapshot",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q9__ebs_snapshot_public_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_snapshot_public_check",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "88120eeb-a914-48e0-9362-f14685c42a78",
      Metadata: {
        TaskRefId: "14d51cb3-80ca-4cf1-ad97-f92fc5998a00",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Identify EBS snapshots are not public, public snapshots are shared with other AWS accounts which can lead to exposing data resides in the snapshot.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "snap-0fefb040fa59d91ac",
      ResourceType: "Snapshot",
      Severity: "Critical",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_snapshot_public_check",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "12a88bdb-46e8-4aa7-9721-1ab0212573db",
      Metadata: {
        TaskRefId: "14d51cb3-80ca-4cf1-ad97-f92fc5998a00",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Identify EBS snapshots are not public, public snapshots are shared with other AWS accounts which can lead to exposing data resides in the snapshot.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "snap-08155855243ecf2be",
      ResourceType: "Snapshot",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q9__rds_automated_backup_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_automated_backup_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "5f9f5c6a-2090-41a4-b07a-ec4ec3c1af8d",
      Metadata: {
        TaskRefId: "ab655176-d83e-4103-8741-51aeb122ffde",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Backups are crucial to meet your current Recovery Point Objective (RPO), the maximum acceptable amount of time since the last backup and Recovery Time Objective (RTO), the maximum acceptable delay between the interruption of service and restoration of services. This check verifies if Automated backups are enabled for RDS.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_automated_backup_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "95d095fc-927b-48bb-af68-e12eb3fc57db",
      Metadata: {
        TaskRefId: "ab655176-d83e-4103-8741-51aeb122ffde",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Backups are crucial to meet your current Recovery Point Objective (RPO), the maximum acceptable amount of time since the last backup and Recovery Time Objective (RTO), the maximum acceptable delay between the interruption of service and restoration of services. This check verifies if Automated backups are enabled for RDS.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q9__volume_backup_check = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "136bfeaf-a2de-4ebd-abeb-cea0e0c93d52",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-0faf25aeab3cb0efa",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "258b9569-f1ef-46a8-93bf-388f64cd0dea",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-0747ba470b9190c04",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "28f65121-9821-4f69-ba4e-81cd97696c9a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-03d385d8a15e6912b",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "32f9d881-4bd2-401b-8e29-e5957ad2fcfc",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-02d23369d29e03152",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "6138dc42-b47c-496a-9ac4-099b314b22a0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-006628696d6276613",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "62237cb0-e2fd-4f6a-bd73-40f891042e4d",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-04519c70f234c739a",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "65d0b5f0-d91b-47c2-a964-80c6f9b4cb40",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-00390a16574adf858",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "acefc496-c507-4e81-bd85-081e920a3efc",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-06ffbd8c4acb516a1",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "dde9948c-2c47-4b17-a57d-39e477efb6ec",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-03698fec3b83c21aa",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "volume_backup_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "f57c1a07-48ca-416e-894e-63d9b6d2995b",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation: "EBS Volumes should have snapshots",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-05ef2b3341707c934",
      ResourceType: "Volume",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 11,
};
export const Reliability_Q9__dynamodb_tables_backed_up = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "dynamodb_tables_backed_up",
      CreatedAt: "2023-04-25 12:24:11",
      FindingId: "61c5195a-5ce3-4cca-871d-1e03689e87ec",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Ensure DynamoDB tables are backed up to avoid potential loss of data",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:dynamodb:us-east-1:181570489212:table/test-table-ba377cb0-e354-11ed-8296-0e94021f48fb",
      ResourceType: "DynamoDbTable",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q9__enable_dynamodb_point_in_time_recovery = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "enable_dynamodb_point_in_time_recovery",
      CreatedAt: "2023-04-25 12:24:09",
      FindingId: "0d6f362f-8f71-4da6-a87b-b4b732a5cc9e",
      Metadata: {
        TaskRefId: "e9f86863-ac62-4ed5-aba7-b55147dceefe",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Ensure that your AWS DynamoDB tables make use of Point-in-time Recovery (PITR) feature in order to automatically take continuous backups of your DynamoDB data",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "test-table-ba377cb0-e354-11ed-8296-0e94021f48fb",
      ResourceType: "DynamoDbTable",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q9__ec2_instance_backup_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_instance_backup_check",
      CreatedAt: "2023-04-25 12:24:08",
      FindingId: "26e3d6ec-0764-4447-bb2d-dcf5595788bc",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Ensure EC2 instances backed up to avoid potential loss of data, The purpose of the backup is to create a copy of data that can be recovered in the event of a primary data failure",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0e72da0097f2af649",
      ResourceType: "Instance",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_instance_backup_check",
      CreatedAt: "2023-04-25 12:24:08",
      FindingId: "9a1e6830-84c8-4a66-b72f-30e53e8f913c",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Ensure EC2 instances backed up to avoid potential loss of data, The purpose of the backup is to create a copy of data that can be recovered in the event of a primary data failure",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-04b1c4e4f9284d09a",
      ResourceType: "Instance",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ec2_instance_backup_check",
      CreatedAt: "2023-04-25 12:24:08",
      FindingId: "b87ddb48-8d80-4d00-9f33-58fc206ea72a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Ensure EC2 instances backed up to avoid potential loss of data, The purpose of the backup is to create a copy of data that can be recovered in the event of a primary data failure",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "i-0eb9f9cc0b178be09",
      ResourceType: "Instance",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 3,
};
export const Reliability_Q9__ebs_snapshot_age_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_snapshot_age_check",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "a1687455-9908-4d8f-9e60-ef6d40a4b41f",
      Metadata: {
        TaskRefId: "e2528df3-a4b3-4676-8ab4-9f84c3fb8f33",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Check for any AWS EBS snapshots older than 30 days available within your AWS account",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "snap-08155855243ecf2be",
      ResourceType: "Snapshot",
      Severity: "Informational",
      Status: "Passed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_snapshot_age_check",
      CreatedAt: "2023-04-25 12:24:42",
      FindingId: "f71cac05-0ab1-4fc9-ba74-ff05935d3709",
      Metadata: {
        TaskRefId: "e2528df3-a4b3-4676-8ab4-9f84c3fb8f33",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Check for any AWS EBS snapshots older than 30 days available within your AWS account",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "snap-0fefb040fa59d91ac",
      ResourceType: "Snapshot",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q9__rds_snapshot_public_access_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_snapshot_public_access_check",
      CreatedAt: "2023-04-25 12:24:48",
      FindingId: "c0c2666d-030d-4a36-8858-8ab65d9c76fe",
      Metadata: {
        TaskRefId: "6480dac2-db43-4c93-b451-ec23abd9df5f",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Ensure that your Relational Database Service (RDS) database snapshots are not publicly accessible (i.e. shared with all AWS accounts and users) in order to avoid exposing your private data.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "wafr-rdsnc-snapshot-a37edcf9-8490-4d5d-ba89-cc0df9cc4534",
      ResourceType: "RdsSnapshot",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_snapshot_public_access_check",
      CreatedAt: "2023-04-25 12:24:48",
      FindingId: "96b997b1-e7e3-4e59-978c-7ec4374533fc",
      Metadata: {
        TaskRefId: "6480dac2-db43-4c93-b451-ec23abd9df5f",
      },
      PillarId: "reliability",
      QuestionId: "backing-up-data",
      Recommendation:
        "Ensure that your Relational Database Service (RDS) database snapshots are not publicly accessible (i.e. shared with all AWS accounts and users) in order to avoid exposing your private data.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId: "wartestrds1noncompliant-181570489212-final-snapshot",
      ResourceType: "RdsSnapshot",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q9__fsx_automated_backup_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

export const Reliability_Q10_Check_Details = [
  {
    CheckId: "sagemaker_model_network_isolation_check",
    Description: "SageMaker model network isolation enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Reliability_Q11_Check_Details = [
  {
    CheckId: "is_dms_multi_az_configured",
    Description:
      "Ensure that your Amazon Database Migration Service (DMS) replication instances are using Multi-AZ deployment configurations to provide High Availability (HA) through automatic failover to standby replicas in the event of a failure such as an Availability ",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_read_replica_check",
    Description: "RDS read replica",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "rds_db_cluster_multiaz_check",
    Description: "RDS Multi AZ",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "documentdb_cluster_configured_for_ha",
    Description:
      "Ensure that DocumentDB Cluster configured for HA or better availability in case of primary instance fails to serve traffic",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "rds_instance_ha_check",
    Description:
      "Ensure that your RDS clusters are deployed across Multi-AZ configurations for high availability and automatic failover support fully managed by AWS",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "redshift_az_relocation_status",
    Description:
      "This rule checks if Redshift AZ relocation status is enabled, By using relocation in Amazon Redshift, you enable Amazon Redshift to move a cluster to another Availability Zone (AZ) without any loss of data or changes to your applications",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "enable_elasticache_redis_multi_az",
    Description: "Enable ElastiCache Redis Multi-AZ",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "neptune_instance_multi_az_check",
    Description: "Neptune Multi-AZ",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Reliability_Q11__is_dms_multi_az_configured = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q11__rds_read_replica_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_read_replica_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "78eae576-69c8-47ee-ab11-f63c8f2ba248",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "withstand-component-failures",
      Recommendation:
        "This rule checks whether read replica is available for RDS.\nAmazon RDS Read Replicas provide enhanced performance and durability for Amazon RDS database (DB) instances.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_read_replica_check",
      CreatedAt: "2023-04-25 12:23:33",
      FindingId: "b67d96b4-4012-459b-b119-2f811c535062",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "withstand-component-failures",
      Recommendation:
        "This rule checks whether read replica is available for RDS.\nAmazon RDS Read Replicas provide enhanced performance and durability for Amazon RDS database (DB) instances.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q11__rds_db_cluster_multiaz_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_db_cluster_multiaz_check",
      CreatedAt: "2023-04-25 12:25:12",
      FindingId: "0a197490-e3ec-4e73-b949-c6457443ebc8",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "withstand-component-failures",
      Recommendation:
        "Ensure that your RDS clusters are deployed accross Multi-AZ configurations for high availability and automatic failover support fully managed by AWS",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "humantech-production-auroradbnc-auroradbclusternc-h0etehondbyg",
      ResourceType: "RdsCluster",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Reliability_Q11__documentdb_cluster_configured_for_ha = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q11__rds_instance_ha_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_ha_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "003711bf-89ea-44b4-a53c-1d1047cd9606",
      Metadata: {
        TaskRefId: "adb1aab2-726a-46cf-a8c0-cfbf055a2431",
      },
      PillarId: "reliability",
      QuestionId: "withstand-component-failures",
      Recommendation:
        "Ensure that your RDS clusters are deployed across Multi-AZ configurations for high availability and automatic failover support fully managed by AWS",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_ha_check",
      CreatedAt: "2023-04-25 12:23:30",
      FindingId: "e1111a92-694b-4c1b-9cf9-e389ada7001a",
      Metadata: {
        TaskRefId: "adb1aab2-726a-46cf-a8c0-cfbf055a2431",
      },
      PillarId: "reliability",
      QuestionId: "withstand-component-failures",
      Recommendation:
        "Ensure that your RDS clusters are deployed across Multi-AZ configurations for high availability and automatic failover support fully managed by AWS",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Reliability_Q11__redshift_az_relocation_status = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q11__enable_elasticache_redis_multi_az = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Reliability_Q11__neptune_instance_multi_az_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "neptune_instance_multi_az_check",
      CreatedAt: "2023-04-25 12:24:57",
      FindingId: "c957523f-2680-479a-992d-6c79cce57fc4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "withstand-component-failures",
      Recommendation:
        "Ensure that your Amazon Neptune graph database clusters are using Multi-AZ deployment configurations to enhance High Availability (HA) through automatic failover to read replicas in the event of a failure such as an Availability Zone (AZ) outage, an internal hardware or network outage, a software failure or in case of planned system maintenance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "wartestrds1noncompliant-181570489212",
      ResourceType: "NeptuneInstance",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "neptune_instance_multi_az_check",
      CreatedAt: "2023-04-25 12:24:57",
      FindingId: "cc62a6c1-0f21-4ed8-abec-a7d3d8ca4898",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "reliability",
      QuestionId: "withstand-component-failures",
      Recommendation:
        "Ensure that your Amazon Neptune graph database clusters are using Multi-AZ deployment configurations to enhance High Availability (HA) through automatic failover to read replicas in the event of a failure such as an Availability Zone (AZ) outage, an internal hardware or network outage, a software failure or in case of planned system maintenance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "NeptuneInstance",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};

export const reliabilityCheckFindings = {
  [`mitigate-interaction-failure_s3_bucket_version_enable`]:
    Reliability_Q5_s3_bucket_version_enable,
  [`monitor-aws-resources_emr_cluster_logging_check`]:
    Reliability_Q6__emr_cluster_logging_check,
  [`monitor-aws-resources_kms_key_rotation_enabled`]:
    Reliability_Q6__kms_key_rotation_enabled,
  [`monitor-aws-resources_kinesis_analytics_application_log_to_cloudwatch_check`]:
    Reliability_Q6__kinesis_analytics_application_log_to_cloudwatch_check,
  [`monitor-aws-resources_cloudtrail_logs_encrypted_at_rest`]:
    Reliability_Q6__cloudtrail_logs_encrypted_at_rest,
  [`monitor-aws-resources_configuration_status_check`]:
    Reliability_Q6__configuration_status_check,
  [`monitor-aws-resources_log_metric_filter_for_security_group_changes`]:
    Reliability_Q6__log_metric_filter_for_security_group_changes,
  [`monitor-aws-resources_log_metric_filter_for_route_table_changes`]:
    Reliability_Q6__log_metric_filter_for_route_table_changes,
  [`monitor-aws-resources_appmesh_logging_check`]:
    Reliability_Q6__appmesh_logging_check,
  [`monitor-aws-resources_rds_enable_event_notification_check`]:
    Reliability_Q6__rds_enable_event_notification_check,
  [`monitor-aws-resources_log_metric_filter_for_unauthorized_api_call_changes`]:
    Reliability_Q6__log_metric_filter_for_unauthorized_api_call_changes,
  [`monitor-aws-resources_amb_fabric_node_chaincode_logging_check`]:
    Reliability_Q6__amb_fabric_node_chaincode_logging_check,
  [`monitor-aws-resources_log_metric_filter_for_without_mfa_signin_changes`]:
    Reliability_Q6__log_metric_filter_for_without_mfa_signin_changes,
  [`monitor-aws-resources_is_cloudwatch_logging_enabled`]:
    Reliability_Q6__is_cloudwatch_logging_enabled,
  [`monitor-aws-resources_cloud_trail_s3_bucket_publicly_accessible_check`]:
    Reliability_Q6__cloud_trail_s3_bucket_publicly_accessible_check,
  [`monitor-aws-resources_log_metric_filter_for_s3_changes`]:
    Reliability_Q6__log_metric_filter_for_s3_changes,
  [`monitor-aws-resources_log_metric_filter_for_aws_config_changes`]:
    Reliability_Q6__log_metric_filter_for_aws_config_changes,
  [`monitor-aws-resources_log_metric_filter_for_iam_policy_changes`]:
    Reliability_Q6__log_metric_filter_for_iam_policy_changes,
  [`monitor-aws-resources_blockchain_fabric_peer_node_logs_enabled`]:
    Reliability_Q6__blockchain_fabric_peer_node_logs_enabled,
  [`monitor-aws-resources_log_metric_filter_for_console_authentication_failure`]:
    Reliability_Q6__log_metric_filter_for_console_authentication_failure,
  [`monitor-aws-resources_elbv2_nlb_tls_logging_check`]:
    Reliability_Q6__elbv2_nlb_tls_logging_check,
  [`monitor-aws-resources_broker_audit_logging_check`]:
    Reliability_Q6__broker_audit_logging_check,
  [`monitor-aws-resources_neptune_cluster_audit_logging_check`]:
    Reliability_Q6__neptune_cluster_audit_logging_check,
  [`monitor-aws-resources_vpc_flow_log_enabled_check`]:
    Reliability_Q6__vpc_flow_log_enabled_check,
  [`monitor-aws-resources_log_metric_filter_for_network_gateway_changes`]:
    Reliability_Q6__log_metric_filter_for_network_gateway_changes,
  [`monitor-aws-resources_log_metric_filter_for_root_account_changes`]:
    Reliability_Q6__log_metric_filter_for_root_account_changes,
  [`monitor-aws-resources_log_metric_filter_for_cmk_api_call_changes`]:
    Reliability_Q6__log_metric_filter_for_cmk_api_call_changes,
  [`monitor-aws-resources_clb_access_logging_check`]:
    Reliability_Q6__clb_access_logging_check,
  [`monitor-aws-resources_cloud_trail_s3_bucket_logging_enabled_check`]:
    Reliability_Q6__cloud_trail_s3_bucket_logging_enabled_check,
  [`monitor-aws-resources_documentdb_cluster_audit_logging_on`]:
    Reliability_Q6__documentdb_cluster_audit_logging_on,
  [`monitor-aws-resources_cloud_trail_multi_region`]:
    Reliability_Q6__cloud_trail_multi_region,
  [`monitor-aws-resources_is_stage_api_logging_enabled`]:
    Reliability_Q6__is_stage_api_logging_enabled,
  [`monitor-aws-resources_cloud_trail_organizational_check`]:
    Reliability_Q6__cloud_trail_organizational_check,
  [`monitor-aws-resources_log_metric_filter_for_aws_cloud_trail_changes`]:
    Reliability_Q6__log_metric_filter_for_aws_cloud_trail_changes,
  [`monitor-aws-resources_redshift_cluster_logging_check`]:
    Reliability_Q6__redshift_cluster_logging_check,
  [`monitor-aws-resources_cloud_trail_log_file_validation`]:
    Reliability_Q6__cloud_trail_log_file_validation,
  [`monitor-aws-resources_are_global_management_events_logged`]:
    Reliability_Q6__are_global_management_events_logged,
  [`monitor-aws-resources_amb_fabric_member_ca_logging_check`]:
    Reliability_Q6__amb_fabric_member_ca_logging_check,
  [`monitor-aws-resources_elb_access_logging_check`]:
    Reliability_Q6__elb_access_logging_check,
  [`monitor-aws-resources_broker_general_logging_check`]:
    Reliability_Q6__broker_general_logging_check,
  [`monitor-aws-resources_log_metric_filter_for_nacl_changes`]:
    Reliability_Q6__log_metric_filter_for_nacl_changes,
  [`monitor-aws-resources_rds_instance_cloudwatch_logging_check`]:
    Reliability_Q6__rds_instance_cloudwatch_logging_check,
  [`monitor-aws-resources_log_metric_filter_for_vpc_changes`]:
    Reliability_Q6__log_metric_filter_for_vpc_changes,
  [`monitor-aws-resources_s3_bucket_logging_enable`]:
    Reliability_Q6__s3_bucket_logging_enable,
  [`monitor-aws-resources_is_cloudwatch_log_forwarding_enabled`]:
    Reliability_Q6__is_cloudwatch_log_forwarding_enabled,
  [`backing-up-data_rds_db_cluster_snapshot_age_check`]:
    Reliability_Q9__rds_db_cluster_snapshot_age_check,
  [`backing-up-data_ebs_snapshot_public_check`]:
    Reliability_Q9__ebs_snapshot_public_check,
  [`backing-up-data_rds_automated_backup_check`]:
    Reliability_Q9__rds_automated_backup_check,
  [`backing-up-data_volume_backup_check`]: Reliability_Q9__volume_backup_check,
  [`backing-up-data_dynamodb_tables_backed_up`]:
    Reliability_Q9__dynamodb_tables_backed_up,
  [`backing-up-data_enable_dynamodb_point_in_time_recovery`]:
    Reliability_Q9__enable_dynamodb_point_in_time_recovery,
  [`backing-up-data_ec2_instance_backup_check`]:
    Reliability_Q9__ec2_instance_backup_check,
  [`backing-up-data_ebs_snapshot_age_check`]:
    Reliability_Q9__ebs_snapshot_age_check,
  [`backing-up-data_rds_snapshot_public_access_check`]:
    Reliability_Q9__rds_snapshot_public_access_check,
  [`backing-up-data_fsx_automated_backup_enabled_check`]:
    Reliability_Q9__fsx_automated_backup_enabled_check,

  [`withstand-component-failures_is_dms_multi_az_configured`]:
    Reliability_Q11__is_dms_multi_az_configured,
  [`withstand-component-failures_rds_read_replica_check`]:
    Reliability_Q11__rds_read_replica_check,
  [`withstand-component-failures_rds_db_cluster_multiaz_check`]:
    Reliability_Q11__rds_db_cluster_multiaz_check,
  [`withstand-component-failures_documentdb_cluster_configured_for_ha`]:
    Reliability_Q11__documentdb_cluster_configured_for_ha,
  [`withstand-component-failures_rds_instance_ha_check`]:
    Reliability_Q11__rds_instance_ha_check,
  [`withstand-component-failures_redshift_az_relocation_status`]:
    Reliability_Q11__redshift_az_relocation_status,
  [`withstand-component-failures_enable_elasticache_redis_multi_az`]:
    Reliability_Q11__enable_elasticache_redis_multi_az,
  [`withstand-component-failures_neptune_instance_multi_az_check`]:
    Reliability_Q11__neptune_instance_multi_az_check,
};
